import type { ErrorDescription } from 'types/handled_error';

export const groupsHandledErrors: ErrorDescription[] = [
  {
    endpoint: 'groups/trades_tags',
    method: 'patch',
    responseStatus: 422,
    error: 'tag_already_created',
  },
  {
    endpoint: 'groups/trades_tags',
    method: 'post',
    responseStatus: 422,
    error: 'tag_already_created',
  },
];
